import { type FormEvent, useState } from 'react';
import { saveRelayConfig } from '../api/client';

interface Props {
  onSaved: () => void;
}

export function SettingsGate({ onSaved }: Props) {
  const [url, setUrl] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState<string | null>(null);

  function submit(e: FormEvent) {
    e.preventDefault();
    if (!url.startsWith('http')) {
      setError('API URL must start with http(s)://');
      return;
    }
    if (!token.trim()) {
      setError('Bearer token required');
      return;
    }
    saveRelayConfig({ url: url.trim(), token: token.trim() });
    onSaved();
  }

  return (
    <div className="grid min-h-screen place-items-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-2">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-emerald-500/20 text-emerald-300 ring-1 ring-inset ring-emerald-500/30">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="10" />
            </svg>
          </span>
          <div>
            <div className="text-sm font-semibold tracking-tight">auto-reddit</div>
            <div className="text-[10px] uppercase tracking-wider text-[var(--color-text-faint)]">
              warming dashboard
            </div>
          </div>
        </div>
        <h1 className="mb-1 text-lg font-semibold tracking-tight">
          Connect to auto-reddit-api
        </h1>
        <p className="mb-6 text-sm text-[var(--color-text-dim)]">
          Stored in this browser only. The URL points at the
          {' '}
          <code className="rounded bg-[var(--color-surface-2)] px-1 py-0.5 text-xs text-zinc-300">
            auto-reddit-api
          </code>
          {' '}Worker (deployed from
          {' '}
          <code className="rounded bg-[var(--color-surface-2)] px-1 py-0.5 text-xs text-zinc-300">
            auto-reddit/api/
          </code>
          ); the token is the
          {' '}
          <code className="rounded bg-[var(--color-surface-2)] px-1 py-0.5 text-xs text-zinc-300">
            API_TOKEN
          </code>
          {' '}you set as a wrangler secret.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <label className="block">
            <span className="mb-1.5 block text-xs font-medium uppercase tracking-wide text-[var(--color-text-faint)]">
              API URL
            </span>
            <input
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://auto-reddit-api.your-zone.workers.dev"
              className="input"
              autoFocus
            />
          </label>
          <label className="block">
            <span className="mb-1.5 block text-xs font-medium uppercase tracking-wide text-[var(--color-text-faint)]">
              Bearer token
            </span>
            <input
              type="password"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="••••••••••••"
              className="input font-mono"
            />
          </label>
          {error && (
            <div className="rounded-md border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-xs text-rose-200">
              {error}
            </div>
          )}
          <button type="submit" className="btn-primary w-full">
            Connect
          </button>
        </form>
      </div>
    </div>
  );
}
